import axios from "axios";
import { getApiRoute } from "src/services";
import { useMutation } from "@tanstack/react-query";

export async function updateTags({ tags }) {
  if (!Array.isArray(tags)) {
    throw new Error("Tags must be an array");
  }

  const response = await axios.post(
    getApiRoute("user", "UPDATE_TAGS"),
    { tags },
    { withCredentials: true }
  );
  return response.data;
}

export const useUpdateTags = (options = {}) => {
  const mutation = useMutation(updateTags, options);
  return mutation;
};
